module.exports = __webpack_public_path__ + "resources/img/img_moai_cooperation_func_m.453db400d0d3f08cccc0eb637fe86aa1.png";